import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import Select from "../../components/select/Select";
//import { browserHistory } from "react-router";
import { checkParams } from "../../../src/util/Util";
import "./Register.css";
import { Context } from "../../context/Context";

function parseAssessmentData(rawData) {
  if (!rawData || typeof rawData !== "object") return null;
  console.log("raw data is : ",rawData)

  const plan = rawData.recoveryPlan || {};
  const exercises = plan.exercises || [];

  const today = new Date().toISOString().split("T")[0];

  const {
    recoveryPlan,
    exercises: _exercises,
    problem_id,
    sub_problem_id,
    clinical_protocol_id,
    rom,
    duration,
    rom2,
    duration2,
    analyticsId,
    ...restUserData
  } = rawData;

  const formatted = {
    program_name: "Week 1 Recovery Plan",
    problem_id: rawData.problem_id || 0,
    sub_problem_id: rawData.sub_problem_id || 0,
    clinical_protocol_id: rawData.clinical_protocol_id || 0,
    rom : rom || rawData.rom || [],
    duration : duration || rawData.duration || [],
    rom2 : rom2 || rawData.rom2 || [],
    duration2 : duration2 || rawData.duration2 || [],
    analyticsId : analyticsId || rawData?.analyticsId || null, 
    tasks: exercises.map((exercise) => ({
      name: exercise.name || "Untitled",
      description: exercise.description || "",
      level: plan.level || "",
      rom: exercise.target_rom_max || 0,
      hold : exercise?.hold,
      duration: exercise.hold_in_seconds || 0,
      reps: exercise.reps || 4,
      sets: exercise.sets || 1,
      task_type: "exercise",
      category_type: 1,
      suggested_date: today,
      question_id: exercise.question_id || 0,
      activity_id: exercise.activity_id || exercise.equipment_id || null,
      set_limb_instruction: exercise.set_limb_instruction || {},
      performance_side: exercise.performance_side || '',
      purpose: exercise.purpose || '',
      rom_max: exercise.target_rom_max || 100,
    })),
    userData: restUserData,
  };
  

  return formatted;
}


const Register = (props) => {
  const { clearAllData } = useContext(Context);
  const [userCompanyData, setUserCompanyData] = useState(
    localStorage.getItem("userCompanyData")
      ? JSON.parse(localStorage.getItem("userCompanyData"))[0]
      : ""
  );
  const[assesmentDataForBackEnd,setAssesmentDataForBackEnd] = useState(null)
  const [sessionId, setSessionId] = useState(null)
  const [fromSelfAssesment, setFromSelfAssesment] = useState(false);
  console.log("from self assesment : ",fromSelfAssesment)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const encodedData = params.get("data");
    if (encodedData) {
      try {
		  axios.post(window.ajaxLink + "user/register_data", {code: encodedData}).then((res) => {
					if (res.data.responseCode === 200) {
						const decoded = atob(res.data.responseData);
						const parsedAssessmentData = JSON.parse(decoded);
						const backendData = parseAssessmentData(parsedAssessmentData);
            setSessionId(backendData.analyticsId)

						localStorage.setItem("assessmentData", JSON.stringify(backendData));
						setAssesmentDataForBackEnd(backendData)
						localStorage.setItem("fromSite", 'https://' + (params.get('fromsite') || 'www.startfreept.com'));
						console.log("Assesment Data is : ",backendData);
						console.log("Assesment Data before paresd for api : ",parsedAssessmentData);
					}
				  });
      } catch (err) {
        console.error("Failed to decode assessmentData from URL:", err);
      }
    }
  }, []);

  // this use-effect will run and check if the user came from the self-assessment flow
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const isSelfAssessment = params.get("self-assessment") === "true";

    if (isSelfAssessment) {
      localStorage.setItem("from_self_assessment", "true");
      setFromSelfAssesment(true);
      console.log("User came from self-assessment flow");
    }
  }, []);

  useEffect(() => {
    clearAllData();
  }, []);

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
  }, [props]);

  useEffect(() => {
    window.onbeforeunload = null;
  }, []);

  let navigate = useNavigate();
  const fromMemberCode =
    document.location.pathname.includes("register-practice");

  if (!fromMemberCode) {
    let businessId = document.location.search.slice(1);
    if (businessId) {
      localStorage.setItem("business_register", parseInt(businessId));
    } else {
      localStorage.setItem("business_register", 0);
    }
  }

  const [firstName, setFirstName] = useState(
    userCompanyData ? userCompanyData.first_name : ""
  );
  const [lastName, setLastName] = useState(
    userCompanyData ? userCompanyData.last_name : ""
  );
  const [email, setEmail] = useState(
    userCompanyData ? userCompanyData.email : ""
  );
  const [city, setCity] = useState("city");
  const [phone, setPhone] = useState(
    userCompanyData ? userCompanyData.phone : ""
  );
  const [errorFirstName, setErrorFirstName] = useState("");
  const [errorLastName, setErrorLastName] = useState("");
  const [errorPhone, setErrorPhone] = useState("");
  const [password, setPassword] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [errorConfirmPassword, setErrorConfirmPassword] = useState("");
  const [validToProceed, setValidToProceed] = useState(false);
  const firstPassword = useRef("");
  const secoundPassword = useRef("");
  const [isChecked, setIsChecked] = useState(false);
  const [hasLocal] = useState(!!localStorage.getItem("userCompanyData"));
  const emailRef = useRef();

  const handleIsChecked = (val) => {
    setIsChecked(val);
  };

  const handleFirstName = (value) => {
    value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    setFirstName(value);
    if (!checkParams(value, "firstname")) {
      setErrorFirstName("Please enter a valid name.");
    } else {
      setErrorFirstName("");
    }
  };

  const handleLastName = (value) => {
    value = value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    setLastName(value);
    if (!checkParams(value, "lastname")) {
      setErrorLastName("Please enter a valid last name.");
    } else {
      setErrorLastName("");
    }
  };

  const handleMail = (value) => {
    setEmail(value);
    if (!checkParams(value.trim(), "email")) {
      setErrorEmail("Please enter a valid email address.");
    } else {
      setErrorEmail("");
    }
  };

  const handlePhone = (subjectString) => {
    var phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    setErrorPhone("");

    if (phoneRegex.test(subjectString)) {
      var formattedPhoneNumber = subjectString.replace(
        phoneRegex,
        "($1) $2-$3"
      );
      setPhone(formattedPhoneNumber);
    } else {
      setErrorPhone("Please enter a valid US mobile number.");
      setPhone(subjectString);
    }
  };

  const handleConfirmPass = (value) => {
    if ((value || confirmPassword) !== password) {
      setErrorConfirmPassword("Passwords don't match.");
    } else {
      setErrorConfirmPassword("");
    }
    setConfirmPassword(value);
    comparePass();
  };

  const comparePass = () => {
    if (firstPassword.current.value === secoundPassword.current.value) {
      setErrorConfirmPassword("");
    }
  };

  // eslint-disable-next-line
  const [countryList] = useState([
    {
      value: "United States",
    },
    { value: "Canada" },
  ]);
  const [canadaStateList, setCanadaStateList] = useState([]);
  const [unitedStateStateList, setUnitedStateStateList] = useState([]);


  const [stateSelected, setStateSelected] = useState("");
  const handleStateSelected = (callVal, value) => {
    if (callVal && value) {
      callVal(value);
      setStateSelectedError("");
    } else {
      setStateSelectedError("Please select a state from the list.");
    }
  };
  const [stateSelectedError, setStateSelectedError] = useState("");
  const [countrySelected, setCountrySelected] = useState(
    userCompanyData ? userCompanyData.country : "United States"
  );

  const attemptValidToProceed = () => {
    handleFirstName(firstName);
    if (!fromSelfAssesment) {
      handleLastName(lastName);
    }
    if (errorEmail !== "This email is already taken, try login instead.") {
      handleMail(email);
    }
    handlePhone(phone);
    handleStateSelected(setStateSelected, stateSelected);
    handlePassError(firstPassword);
    handleConfirmPassError(secoundPassword);
  };

  const handlePassError = () => {
    if (!firstPassword.current.value) {
      setPasswordError("Please enter a valid password.");
    }
  };
  const handleConfirmPassError = () => {
    if (!secoundPassword.current.value) {
      setErrorConfirmPassword("Please confirm your password.");
    }
  };
  
  const checkValidToProceed = () => {
    if (
      firstName?.length > 1 &&
      errorFirstName?.length === 0 &&
      (fromSelfAssesment || (lastName?.length > 1 && errorLastName?.length === 0)) &&
      email?.length > 0 &&
      errorEmail?.length === 0 &&
      stateSelected?.length > 0 &&
      phone?.length > 0 &&
      errorPhone === "" &&
      passAllValid &&
      confirmPassword.length > 0 &&
      errorConfirmPassword.length === 0 &&
      isChecked === true
    ) {
      setValidToProceed(true);
    } else {
      setValidToProceed(false);
    }
  };

  const proceedToNextStep = () => {
    if (userCompanyData) {
      if (userCompanyData.birthday.indexOf("/") !== -1) {
        var strDate = userCompanyData.birthday.split("/");
        strDate = strDate[2] + "-" + strDate[0] + "-" + strDate[1];
        userCompanyData.birthday = strDate;
      }
    }

    axios
      .post(window.ajaxLink + "user/register", {
        firstName: firstName.trim(),
        lastName: fromSelfAssesment ? (lastName || "") : lastName.trim(),
        birthday: userCompanyData ? userCompanyData.birthday : "",
        email: email.trim().toLowerCase(),
        city: city.trim(),
        country: countrySelected,
        state: stateSelected,
        phone: phone,
        password: password.trim(),
        session_id : sessionId,
        company_id: localStorage.getItem("company_id")
          ? localStorage.getItem("company_id")
          : 0,
        business_id: localStorage.getItem("business_register")
          ? localStorage.getItem("business_register")
          : 0,
        newMemberRegister: true,
        company_doctor_id: userCompanyData
          ? userCompanyData.company_doctor_id
          : 0,
        patient_code: patientCode ? patientCode : "",
        assessmentData: JSON.parse(localStorage.getItem("assessmentData")) || assesmentDataForBackEnd,
      })
      .then((res) => {
        if (res.data.responseCode === 200) {
          localStorage.setItem(
            "userData",
            JSON.stringify(res.data.responseData)
          );
          localStorage.setItem("isNew", "true");
          props.checkLoggedIn(true);
          navigate("/verify");
        }
      })
      .catch((error) => {
        console.error(error);
        if (error.response.data.errorData.emailErr) {
          setErrorEmail(error.response.data.errorData.emailErr);
          if (emailRef.current) {
            emailRef.current.focus();
            emailRef.current.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
          setValidToProceed(false);
        }
      });
  };

  const [passAllValid, setPassAllValid] = useState(false);
  const [charLengthValid, setCharLengthValid] = useState(false);
  const [hasLetter, setHasLetter] = useState(false);
  const [hasNum, setHasNum] = useState(false);
  const [hasSpecChar, setHasSpecChar] = useState(false);
  const [passwordError, setPasswordError] = useState("");

  const sweepThroughTickers = (value) => {
    setPasswordError("");
    setCharLengthValid(checkParams(value, "charLength"));
    setHasLetter(checkParams(value, "hasLetter"));
    setHasNum(checkParams(value, "hasNum"));
    setHasSpecChar(checkParams(value, "hasSpecChar"));
    setPassword(value);
    if (
      checkParams(value, "charLength") &&
      checkParams(value, "hasLetter") &&
      checkParams(value, "hasNum") &&
      checkParams(value, "hasSpecChar")
    ) {
      setPassAllValid(true);
    } else {
      setPassAllValid(false);
    }
    handleConfirmPass(value);
  };

  const [passVisible, setPassVisible] = useState(false);
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);

  useEffect(() => {
    checkValidToProceed();
    // eslint-disable-next-line
  }, [
    firstName,
    lastName,
    email,
    city,
    phone,
    stateSelected,
    password,
    passAllValid,
    confirmPassword,
    isChecked,
  ]);

  useEffect(() => {
    axios
      .post(window.ajaxLink + "cloud_therapist/getStateList", {})
      .then((res) => {
        if (res.data.responseData) {
          var unitedStates = [];
          var canada = [];

          for (var country of res.data.responseData) {
            if (country.country === "United States") {
              unitedStates.push(country);
            } else {
              canada.push(country);
            }
          }

          setCanadaStateList(canada);
          setUnitedStateStateList(unitedStates);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const { patientCode } = useParams();

  useEffect(() => {
    // if (!hasLocal && !patientCode) {
    //   navigate("/signup");
    // }
    if (patientCode) {
      axios
        .post(window.ajaxLink + "user/checkForPatientCode", {
          patient_code: patientCode,
        })
        .then((res) => {
          if (res.data.responseData) {
            if (res.data.responseCode === 200) {
              localStorage.setItem(
                "userCompanyData",
                JSON.stringify(res.data.responseData)
              );
              setUserCompanyData(res.data.responseData[0]);
              handleFirstName(res.data.responseData[0].first_name);
              handleLastName(res.data.responseData[0].last_name);
              handleMail(res.data.responseData[0].email);
              handlePhone(res.data.responseData[0].phone);
              setCountrySelected(res.data.responseData[0].country);

              localStorage.setItem(
                "userMainTherapist",
                JSON.stringify(res.data.responseData[0].therapist_id)
              );
              localStorage.setItem(
                "company_id",
                res.data.responseData[0].company_id
              );
              //localStorage.setItem("company_name", res.data.responseData[0].company_name);
              localStorage.setItem(
                "business_register",
                res.data.responseData[0].business_id
                  ? res.data.responseData[0].business_id
                  : 0
              );
            }
          }
        })
        .catch((error) => {
          if (error.response.data.errorData === "no user found") {
            navigate("/signup");
            localStorage.removeItem("userCompanyData");
          } else if (
            error.response.data.errorData === "user already registered"
          ) {
            navigate("/login");
            localStorage.removeItem("userCompanyData");
          }
        });
    }
    // eslint-disable-next-line
  }, [hasLocal]);

  return (
    <div className="register_full_background">
      <div className="logo_img_header register_upper_logo"></div>
      <div className="register_image"></div>
      <div className="main_register_container">
        <div className="register_already_have">
          Already have an account?<Link to={"/login"}> Sign in</Link>
        </div>
        <div className="cloud_register_holder">
          <div className="register_sign_title">{fromSelfAssesment ? "Sign Up to Continue Your Recovery Journey" : "Sign up for Virdio Health"}</div>
          <div className="register_explanation">
            {fromSelfAssesment ? "Unlock your first week of guided recovery with AI-powered exercises, progress tracking, reminders, and more. Let's get started!" : "To ensure that you have a safe experience on Virdio Health, you first need to answer some questions about your health."}
          </div>
          <div className="info_row_holder">
            <div className="reg_form_title">
              {fromSelfAssesment ? "Name" : "Patient's Name"}
            </div>
            <div className="relative_holder flex flex-col sm:flex-row gap-[10px] w-full">
              <input
                type="text"
                tabIndex="1"
                placeholder="First Name"
                className={
                  "reg_input reg_input_split" +
                  (errorFirstName ? " err_inp_register" : "")
                }
                onChange={(e) => handleFirstName(e.currentTarget.value)}
                value={firstName}
                disabled={
                  userCompanyData && userCompanyData.first_name ? true : false
                }
              />
              <input
                type="text"
                tabIndex="2"
                placeholder="Last Name"
                className={
                  "reg_input reg_input_split" +
                  (errorLastName ? " err_inp_register" : "")
                }
                onChange={(e) => handleLastName(e.currentTarget.value)}
                value={lastName}
                disabled={
                  userCompanyData && userCompanyData.last_name ? true : false
                }
              />
            </div>
            {(errorFirstName || (!fromSelfAssesment && errorLastName)) && (
              <div className="email_error_msg">
                {errorFirstName || errorLastName}
              </div>
            )}
            <div className="reg_form_title">Email Address</div>
            <div className="relative_holder">
              <input
                type="email"
                tabIndex="3"
                value={email}
                placeholder="john@email.com"
                ref={emailRef}
                className={
                  "reg_input" + (errorEmail ? " err_inp_register" : "")
                }
                onChange={(e) => handleMail(e.currentTarget.value)}
                disabled={
                  userCompanyData && userCompanyData.email ? true : false
                }
              />
              {errorEmail && (
                <div className="email_error_msg">{errorEmail}</div>
              )}
            </div>

            <input
              type="hidden"
              tabIndex="3"
              placeholder="Enter City"
              value="city"
              className="reg_input reg_input_split reg_is_first"
            />

            {/* <div className="reg_form_title">Patient's Country</div>
            <div className="relative_holder reg_select_wrapper">
              <div>
                <Select
                  placeholder={"Select Country"}
                  selectOptions={countryList}
                  selectCallback={function (callVal, value) {
                    setStateSelected("");
                    callVal(value);
                  }}
                  initVal={"United States"}
                  callBackValue={setCountrySelected}
                />
              </div>
            </div> */}

            <div className="reg_form_title" style={{ width: "100%" }}>
              {!fromSelfAssesment && "Patient's "}
              {countrySelected === "Canada"
                ? "Province with time zone"
                : "State"}
            </div>
            <div
              className={
                "relative_holder reg_select_wrapper" +
                (!stateSelected && stateSelectedError
                  ? " reg_select_error"
                  : "")
              }
            >
              <div>
                <Select
                  placeholder={"Select State"}
                  initVal={stateSelected}
                  selectOptions={(countrySelected === "United States"
                    ? unitedStateStateList
                    : canadaStateList
                  ).map((val) => ({ value: val.value }))}
                  selectCallback={function (callVal, value) {
                    handleStateSelected(callVal, value);
                  }}
                  callBackValue={setStateSelected}
                  selectError={!stateSelected && stateSelectedError}
                  selectSearch={true}
                  useHeight={true}
                  useTabIndex="4"
                />
                {stateSelectedError && (
                  <div className="email_error_msg">{stateSelectedError}</div>
                )}
              </div>
            </div>
            <div className="reg_form_text">
              {fromSelfAssesment ? "" : "So, we can match you with a licensed PT in your"}
            </div>
            <div className="reg_form_title">Mobile Number</div>
            <div className="relative_holder">
              <input
                type="text"
                tabIndex="5"
                placeholder="e.g. 202-333-2222"
                value={phone}
                className={
                  "reg_input" + (errorPhone ? " err_inp_register" : "")
                }
                onChange={(e) => handlePhone(e.currentTarget.value)}
                disabled={
                  userCompanyData && userCompanyData.phone ? true : false
                }
              />
              {errorPhone && (
                <div className="email_error_msg">{errorPhone}</div>
              )}
            </div>
            <div className="reg_form_text">
              You will use your mobile number to sign into the app and receive
              texts. Standard rates apply.
            </div>
            <div className="reg_form_title">Password</div>
            <div className="relative_holder">
              <input
                type={passVisible ? "text" : "password"}
                className={
                  "reg_input" + (passwordError ? " err_inp_register" : "")
                }
                tabIndex="6"
                ref={firstPassword}
                onChange={(e) => sweepThroughTickers(e.currentTarget.value)}
                onCopy={(e) => {
                  e.preventDefault();
                  return false;
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  return false;
                }}
              />
              <div
                className="eye_show"
                onClick={() => setPassVisible(!passVisible)}
              >
                {passVisible && <div className="crossed_eye"></div>}
              </div>
            </div>
            {passwordError && (
              <div className="email_error_msg">{passwordError}</div>
            )}
            <>
              {password.length > 0 &&
                (!charLengthValid || !hasLetter || !hasNum || !hasSpecChar) && (
                  <>
                    <div className="reg_pass_check_contain">
                      <div
                        className={
                          "reg_pass_ticker" +
                          (charLengthValid ? " rpass_true" : "")
                        }
                      ></div>
                      Must be at least 8 characters
                    </div>
                    <div className="reg_pass_check_contain">
                      <div
                        className={
                          "reg_pass_ticker" + (hasLetter ? " rpass_true" : "")
                        }
                      ></div>
                      Minimum 1 Letter
                    </div>
                    <div className="reg_pass_check_contain">
                      <div
                        className={
                          "reg_pass_ticker" + (hasNum ? " rpass_true" : "")
                        }
                      ></div>
                      Minimum 1 Number
                    </div>
                    <div className="reg_pass_check_contain">
                      <div
                        className={
                          "reg_pass_ticker" + (hasSpecChar ? " rpass_true" : "")
                        }
                      ></div>
                      Minimum 1 Special character
                    </div>
                  </>
                )}
            </>
            <div className="reg_form_title">Confirm Password</div>
            <div className="relative_holder">
              <input
                type={confirmPassVisible ? "text" : "password"}
                className={
                  "reg_input" +
                  (errorConfirmPassword ? " err_inp_register" : "")
                }
                tabIndex="7"
                ref={secoundPassword}
                onChange={(e) => handleConfirmPass(e.currentTarget.value)}
                onCopy={(e) => {
                  e.preventDefault();
                  return false;
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  return false;
                }}
              />
              <div
                className="eye_show"
                onClick={() => setConfirmPassVisible(!confirmPassVisible)}
              >
                {confirmPassVisible && <div className="crossed_eye"></div>}
              </div>
            </div>
            <>
              {errorConfirmPassword && (
                <div className="email_error_msg">{errorConfirmPassword}</div>
              )}
            </>
            <div className="relative_holder">
              <div
                className={
                  errorConfirmPassword.length === 0
                    ? "check_terms_container"
                    : ""
                }
              >
                <div
                  className={
                    "register_check " + (isChecked ? "register_checked" : "")
                  }
                  onClick={() => handleIsChecked(!isChecked)}
                ></div>
                <div className="terms_privacy_policy">
                  I have read and agree to{" "}
                  <a
                    style={{ color: "#166273" }}
                    href={"https://www.virdiohealth.com/terms"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Virdio Health’s Terms of Service
                  </a>
                  ,{" "}
                  <a
                    style={{ color: "#166273" }}
                    href={"https://www.virdiohealth.com/privacy"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Privacy Notice
                  </a>
                  ,
                  <a
                    style={{ color: "#166273" }}
                    href={"https://www.virdiohealth.com/hipaa-notice"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    HIPAA Notice
                  </a>
                  {!fromSelfAssesment && ", and "}
                  {!fromSelfAssesment ? (
                    <a
                      style={{ color: "#166273" }}
                      href={
                        "https://www.virdiohealth.com/virdio-health-consent-to-telehealth-services"
                      }
                      target="_blank"
                      rel="noreferrer"
                    >
                      Telehealth Consent Terms
                    </a>
                  ) : (
                    ""
                  )}
                  .
                </div>
              </div>
            </div>
          </div>
          <div className="bottomLoginPadding">
            <div
              className={
                "signNewButton reg_procc_btn" +
                (!validToProceed ? " reg_procc_disabled" : "")
              }
              onClick={() =>
                validToProceed ? proceedToNextStep() : attemptValidToProceed()
              }
            >
              Get Started
            </div>
          </div>
          <div className="register_already_have_scnd">
            Already have an account?<Link to={"/"}> Sign in</Link>
          </div>
          {/*<div className="borderMainHolder">
          <div className="bottomBorderPart"></div>
          <div className="orTextPart">OR</div>
          <div className="bottomBorderPart"></div>
        </div>
        <div className="otherLoginHolder">
          <div className="fbButtonPart" id="openFb">
            <div className="fbLogoImg"></div>
            <div className="fbText">Continue with Facebook</div>
          </div>
          <div className="fbButtonPart appleBtnPadding">
						<div    
							id="appleid-signin" 
							className="signin-button" 
							data-color="white"     
							data-border="false" 
							data-type="sign-in"
							data-mode="center-align"
							data-width="100%"
						></div>
					</div>
          
						<div className="fbButtonPart">
							<div className="fbLogoImg googleLogo"></div>
							<div className="fbText">Continue with Google</div>
						</div>
					
        </div> */}
        </div>
      </div>
    </div>
  );
};

export default Register;
